import DocumentTitle from '../Components/DocumentTitle';
import { Card, CardBody, CardTitle, Button, Row, Col } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import OurIdentity from '../Components/OurIdentity';
import CompanyValues from '../Components/CompanyValues';
import WhyUs from '../Components/WhyUs';
import QuickService from '../Components/QuickService';
import { categories } from '../Data/data';

const Home = () => {
    const navigate = useNavigate();

    return (
        <div className='container'>
            <DocumentTitle title="Home" />

            {/* Static Data */}
            <OurIdentity />
            {/* !Static Data */}

            {/* Categories */}
            <h3>Categories</h3>
            <Row>
                {categories.map((category, index) => (
                    <Col className='my-3' key={index} xs='12' sm='12' md='3' lg='3'>
                        <Card style={{ cursor: 'pointer' }}>
                            <img src={category.img} height='190px' width='100%' alt="img not found here..." />
                            <CardBody>
                                <CardTitle className='text-center bold'><h5>{category.heading}</h5></CardTitle>
                            <Button className='w-100' size='sm' color='danger' onClick={() => navigate(`/detail/${category.slug}`)}>Book Now</Button>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
            {/* !Categories */}

            {/* Cards */}
            <CompanyValues />
            {/* !Cards */}

            {/* Why we */}
            <WhyUs />
            {/* !Why we */}

            {/* Quick Service */}
            <QuickService />
            {/* !Quick Service */}
        </div>
    )
};

export default Home;